__turbopack_context__.v({
  "bronze": "Badge-module__0_y8bG__bronze",
  "dark-grey": "Badge-module__0_y8bG__dark-grey",
  "green": "Badge-module__0_y8bG__green",
  "grey": "Badge-module__0_y8bG__grey",
  "light-bronze": "Badge-module__0_y8bG__light-bronze",
  "light-grey": "Badge-module__0_y8bG__light-grey",
  "normal": "Badge-module__0_y8bG__normal",
  "orange": "Badge-module__0_y8bG__orange",
  "red": "Badge-module__0_y8bG__red",
  "small": "Badge-module__0_y8bG__small",
  "x-small": "Badge-module__0_y8bG__x-small",
});
